import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["displayTime"];

  static values = {
    eventAt: String,
  };

  updateTimes(eventAtValue) {
    const displayTime = () => {
      const timeSince = new Date().getTime() - eventAtValue;

      if (this.displayTimeTarget) {
        const minutes = this.minutesFromTime(timeSince);
        this.displayTimeTarget.innerHTML = `${minutes} minute${
          minutes === 1 ? "" : "s"
        } ago`;
      }
    };

    displayTime();

    this.interval = setInterval(displayTime, 1000);
  }

  minutesFromTime(time) {
    return Math.floor(time / (1000 * 60));
  }

  connect() {
    const eventAtValue = new Date(this.eventAtValue).getTime();

    this.updateTimes(eventAtValue);
  }

  disconnect() {
    clearInterval(this.interval);
  }
}
